import React, { Component } from "react";
import "./lente-pronta-confirmed.css";
import AppContext from "../../appContext";
import CustomButton from "../../components/buttons/button";
import IconConfirmed from "../../pedido-atacado/pedido-atacado-confirmed/confirmed-icon";
import PDFOrderLentePronta from "../pdf-order/pdf-order-lente-pronta";
import { Redirect } from "react-router";
import moment from "moment";
import CnpjUtils from "../../shared/utils/CnpjUtils";

class LenteProntaConfirmed extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      redirectL: false,
      redirectHome: false,
    };

    LenteProntaConfirmed.contextType = AppContext;

    if (sessionStorage.getItem("token") !== null) {
      var token = sessionStorage.getItem("token");
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join(""),
      );

      var jwt = JSON.parse(jsonPayload);
      const role = jwt.modulos.find(element => element === "Lente Pronta");
      if (!role) {
        this.state = { redirect: true };
      }
    } else {
      this.state = { redirectL: true };
    }
    if (this.props.location.state === undefined) {
      this.state = { redirectHome: true };
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/home" />;
    }
    if (this.state.redirectL) {
      return <Redirect to="/" />;
    }
    if (this.state.redirectHome) {
      return <Redirect to="/lente-pronta" />;
    }

    const {
      pedido, orcamento, pacto, labName, labCnpj, labLogo, otica, redeOticas,
      empresa_faturamento, dados_empresa_faturamento_cnpj, produtos, prescricaoOlhos, prescricao_OD, prescricao_OE,
      observacao, pedidoOtica, codigoParticipante,
    } = this.props.location.state;
    const idPedido = pedido?.id || pedido?.codigo || "";
    const prazo = orcamento?.dataPrevistaEntrega || "";
    const prazoFormatado = prazo ? moment(prazo).format("DD/MM/YYYY") : "-";
    const hasVoucherPacto = pacto?.useVoucher && pacto?.selectedVoucher;
    const voucherCodigo = pacto?.selectedVoucher?.codigo || "";

    const isOtica = this.context.userSession.papelCategoria === "OTICA";
    const nomeOtica = empresa_faturamento || CnpjUtils.formatCnpj(dados_empresa_faturamento_cnpj);
    const showFraseOtica = !isOtica && !!dados_empresa_faturamento_cnpj;

    return (
      <div className="x-order-confirmed-lente-pronta">
        <main className="x-order-confirmed__main" id="main-body">
          <IconConfirmed />

          <div className="x-order-confirmed__container1">
            <h1 className="x-order-confirmed__title">Seu pedido foi confirmado</h1>
            <p className="x-order-confirmed__paragraph">Parabéns! Você completou seu pedido.</p>
            {showFraseOtica && (
              <p
                className="x-order-confirmed__paragraph x-order-confirmed__paragraph--inline"
                style={{ wordBreak: "break-word", marginTop: "40px" }}
              >
                Seu pedido foi enviado ao Laboratório <strong>{labName}</strong> em nome da ótica <strong>{nomeOtica}</strong>
              </p>
            )}
            <div className="x-order-confirmed__list">
              <p className="x-order-confirmed__item">
                O número do seu pedido no <br />
                laboratório <small className="x-order-confirmed__item--lab">{labName || ""}</small> é{" "}
                <small className="x-order-confirmed__item--number">{idPedido}</small>
              </p>
              <p style={{ textAlign: "center" }} className="x-order-confirmed__item js--paragraph">
                A data de saída estimada é <br />
                <small className="x-order-confirmed__item--number">
                  {prazoFormatado}
                </small>
              </p>
            </div>
            {hasVoucherPacto && (
              <div id="confirmed-voucher-badge" className="x-order-confirmed__voucher">
                Voucher Pacto aplicado: <strong>{voucherCodigo}</strong>
              </div>
            )}

            <PDFOrderLentePronta
              label="Imprimir Pedido"
              btn_class="x-order-confirmed__print-link"
              pedidoId={idPedido}
              pedidoOtica={pedidoOtica}
              prazo={prazoFormatado}
              laboratorio_nome={labName}
              laboratorio={labCnpj}
              otica={otica}
              redeOticas={redeOticas}
              empresa_faturamento={empresa_faturamento}
              produtos={produtos}
              prescricaoOlhos={prescricaoOlhos}
              prescricao_OD={prescricao_OD}
              prescricao_OE={prescricao_OE}
              observacao={observacao}
              codigoParticipante={codigoParticipante}
              valorLiquido={orcamento?.valorLiquido}
              pacto={pacto}
              labLogo={labLogo}
            />

            <div className="button-mobile-only">
              <CustomButton
                id="btn-novo-pedido"
                label="Fazer novo pedido"
                width="14rem"
                icon_arrow_right
                orange_button
                onClick={() => {
                  window.location = "/lente-pronta";
                }}
              />
            </div>
          </div>
        </main>
      </div>
    );
  }
}

export default LenteProntaConfirmed;
